/*--------------------------------------------------------------------------------------------------------------------------
IF ANY CHANGES MADE IN FOOTER FILE THEN THESE CHANGES MUST BE ADDED IN IMAGEEXTRACTOR FOOTER FILE
--------------------------------------------------------------------------------------------------------------------------*/
import React, { useContext } from "react";
import { Col, Layout, Row, Typography, Space, Image } from "antd";
import { GlobalOutlined, MailOutlined } from "@ant-design/icons";
import constants from "../../constants/Constants"
import logo from "../../logo.svg"
import { Link, useLocation } from "react-router-dom";
import { COOKIE, getCookie } from "../../services/Cookie";
import { frontendurls } from "../../constants/FrontendURLs";
import { UserContext } from "./Context";
const { Footer } = Layout;
const { Title } = Typography;

const Footers = () => {
  const location = useLocation();
  const userID = getCookie(COOKIE.UserId);
  const userType = getCookie(COOKIE.UserType);
  const context = useContext(UserContext);

  return (
    <Footer className="p-0">
      <div className="second-banner">
        <div className="text-white container mx-auto pt-10 pb-6 px-4">
          <Row gutter={[24, 24]} justify="center" align="top">
            <Col xs={24} sm={12} md={10}>
              <Image src={logo} alt="Plural Publishing Image Bank" preview={false} width={120} className="white-logo" />
              {constants.AboutPlural}
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Title level={4} className="!text-white">{constants.UsefulLinks}</Title>
              <Space direction="vertical" size="middle" className="mt-2 text-base">
                <Link
                  to={userType === "1" ? frontendurls.ListImages : frontendurls.ViewImages}
                  className={`${location.pathname === (userType === "1" ? frontendurls.ListImages : frontendurls.ViewImages) ? "text-secondary underline" : "hover:!text-white hover:underline"}`}
                >
                  {constants.ListImage}
                </Link>

                {userID && userType === "1" && (
                  <Link
                    to={frontendurls.UserRequests}
                    className={`${location.pathname === frontendurls.UserRequests ? "text-secondary underline" : "hover:!text-white hover:underline"}`}
                  >
                    {constants.UserRequests}
                  </Link>
                )}

                {userID && userType === "1" && (
                  <Link
                    to={frontendurls.AdminListing}
                    className={`${location.pathname === frontendurls.AdminListing ? "text-secondary underline" : "hover:!text-white hover:underline"}`}
                  >
                    {constants.AdminUsers}
                  </Link>
                )}

                {userID && userType === "0" && (
                  <Link
                    to={frontendurls.MyRequests}
                    className={`${location.pathname === frontendurls.MyRequests ? "text-secondary underline" : "hover:!text-white hover:underline"}`}
                  >
                    {constants.MyRequests}
                  </Link>
                )}

                {userID && userType === "0" && (
                  <Link
                    to={frontendurls.ViewCollections}
                    className={`${location.pathname === frontendurls.ViewCollections ? "text-secondary underline" : "hover:!text-white hover:underline"}`}
                  >
                    {constants.MyCollections} {context.cartCount === '0' ? '' : `(${context?.cartCount})`}
                  </Link>
                )}
                <Link
                  to={frontendurls.FAQs}
                  className={`${location.pathname === frontendurls.FAQs ? "text-secondary underline" : "hover:!text-white hover:underline"}`}
                >
                  {constants.FAQs}
                </Link>
                <Link
                  to={frontendurls.PrivacyPolicy}
                  className={`${location.pathname === frontendurls.PrivacyPolicy ? "text-secondary underline" : "hover:!text-white hover:underline"}`}
                >
                  {constants.PrivacyPolicy}
                </Link>
              </Space>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Title level={4} className="!text-white">{constants.Contact}</Title>
              <Space direction="vertical" size="middle">
                <i className="text-lg">{constants.ContactPhrase}</i>

                <Space>
                  <MailOutlined />
                  {constants.ContactEmail}
                </Space>
              </Space>

              <Title level={4} className="!text-white mt-4">{constants.VisitSite}</Title>
              <Space>
                <GlobalOutlined />
                {constants.PluralPublishingSiteLink}
              </Space>

              {/* <Space>
              <PhoneOutlined />
              <Link to="/call" aria-label="Phone Contact" className="hover:!text-white hover:underline text-base">
                1-866-758-7251
              </Link>
            </Space> */}

              {/* <div className="social">
              <Space size={'large'}>
                <Link to="https://www.facebook.com/pluralpub" aria-label="Facebook"><FacebookOutlined /></Link>
                <Link to="https://www.twitter.com/pluralpub" aria-label="Twitter"><XOutlined /></Link>
                <Link to="https://www.instagram.com/pluralpub/" aria-label="Instagram"><InstagramOutlined /></Link>
                <Link to="https://www.linkedin.com/company/plural-publishing-inc-/" aria-label="LinkedIn"><LinkedinOutlined /></Link>
                <Link to="https://www.youtube.com/user/pluralpublishing" aria-label="YouTube"><YoutubeOutlined /></Link>
                <Link to="http://pinterest.com/PluralPub" aria-label="Pinterest"><PinterestOutlined /></Link>
              </Space>
            </div> */}

            </Col>
          </Row>
        </div>
      </div>
      <div className="text-center text-primary py-2 px-12 bg-[#F4F4F3]">
        <Space className="justify-center">
          <span>Plural's Image Bank © {new Date().getFullYear()} Plural Publishing, Inc. All rights reserved. </span>
        </Space>
      </div>
    </Footer>
  )
}
export default Footers;
